/**
 * tRPC Provider for Vite + React Router
 * Wraps the app with tRPC and React Query providers
 */
import { api, getTRPCClientConfig } from '@/utils/api';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

interface TRPCProviderProps {
    children: ReactNode;
}

export function TRPCProvider({ children }: TRPCProviderProps) {
    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        refetchOnWindowFocus: false,
                    },
                },
            }),
    );

    const [trpcClient] = useState(() => api.createClient(getTRPCClientConfig()));

    return (
        <api.Provider client={trpcClient} queryClient={queryClient}>
            <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </api.Provider>
    );
}
